import { FormInstance, Radio, message } from 'antd';
import { useWatch } from 'antd/lib/form/Form';
import { useState, useEffect } from 'react';
import { Modal, Form, FormItemInput, Select, FormItemDatePicker } from '..';
import { segregationTypes } from '../../utils/lists';
import { useSegregateChassiMutation } from '../../services/warehousingVehiclesApi';

const NOT_SHIPPED = 'NOT_SHIPPED';
const DAMAGED = 'DAMAGED';
const NOT_DEPOSITED = 'NOT_DEPOSITED';

type SegregateChassisModalProps = {
  title: string;
  isVisible: boolean;
  okText: string;
  cancelText: string;
  onCancel: () => void;
  onFinish?: () => void;
  chassisId?: number;
};

export function SegregateChassisModal(props: SegregateChassisModalProps) {
  const {
    title,
    isVisible,
    okText,
    cancelText,
    onCancel,
    onFinish,
    chassisId,
  } = props;

  const [form] = Form.useForm();
  const segregationType = useWatch('segregationType', form);
  const removeVehicleFromWarehouse = useWatch(
    'removeVehicleFromWarehouse',
    form
  );

  const [segregateChassi, { isLoading }] = useSegregateChassiMutation();

  const handleFinish = async (values: any) => {
    const shouldRemoveVehicleFromWarehouse =
      (segregationType === DAMAGED && values.removeVehicleFromWarehouse) ||
      segregationType === NOT_DEPOSITED;

    if (!chassisId) {
      message.error('Chassi não fornecido.');
      return;
    }
    try {
      const payload = {
        chassi_id: chassisId,
        segregation_reason: values.segregationReason || '',
        segregation_type: values.segregationType,
        remove_vehicle_from_warehouse:
          shouldRemoveVehicleFromWarehouse || false,
        warehouse_removal_date: values.warehouseRemovalDate
          ? values.warehouseRemovalDate.format('YYYY-MM-DD HH:mm')
          : null,
      };

      await segregateChassi(payload).unwrap();
      form.resetFields();
      if (onFinish) {
        onFinish();
      }
      message.success('Veículo segregado com sucesso!');
    } catch (error) {
      message.error('Erro ao segregar o veículo.');
    }
  };

  return (
    <Modal
      title={title}
      visible={isVisible}
      okText={okText}
      cancelText={cancelText}
      okButtonProps={{
        htmlType: 'submit',
        form: 'segregate',
        loading: isLoading,
      }}
      onCancel={onCancel}
      destroyOnClose
    >
      <Form
        layout="vertical"
        name="segregate"
        onFinish={handleFinish}
        form={form}
      >
        <Form.Item
          name="segregationType"
          label="Tipo da Segregação"
          rules={[
            { required: true, message: 'Selecione o tipo da segregação' },
          ]}
        >
          <Select options={segregationTypes} />
        </Form.Item>

        {segregationType === DAMAGED && (
          <>
            <Form.Item
              name="removeVehicleFromWarehouse"
              label="Remover veículo do pátio?"
              rules={[{ required: true, message: 'Selecione uma opção' }]}
              initialValue={false}
            >
              <Radio.Group>
                <Radio value>Sim</Radio>
                <Radio value={false}>Não</Radio>
              </Radio.Group>
            </Form.Item>

            {removeVehicleFromWarehouse && (
              <FormItemDatePicker
                name="warehouseRemovalDate"
                label="Data da remoção do pátio"
                rules={[{ required: true, message: 'Selecione a data' }]}
                minuteStep={15}
              />
            )}
          </>
        )}

        <FormItemInput name="segregationReason" label="Descrição da avaria" />
      </Form>
    </Modal>
  );
}
